import { createElement, PureComponent } from 'react';
import { string, bool, array, object, func, element, shape } from 'prop-types';
import { f as _defineProperty, e as _inheritsLoose, g as _assertThisInitialized, b as _objectWithoutPropertiesLoose, c as _extends, a as _objectSpread } from '../chunk-ad6ad343.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import InlineBlock from 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import _omit from 'lodash/omit';
import ConditionalWrap from 'conditional-wrap';
import { formikField, reduxFormField } from '../adaptors/fields.js';
import { a as FieldWrapper, b as fieldWrapperPropTypes, c as fieldWrapperDefaultProps } from '../chunk-1195bf9a.js';
import Group from '../Group/index.js';
import _Select, { LoadingSpinner } from './styled.js';
import Icon from './Icon.js';
var selectDefaultProps = {
  a11yId: undefined,
  a11yLabel: undefined,
  autoComplete: undefined,
  autoFocus: false,
  className: undefined,
  defaultValue: undefined,
  disabled: false,
  isFullWidth: false,
  isLoading: false,
  isRequired: false,
  name: undefined,
  onBlur: undefined,
  onChange: undefined,
  onFocus: undefined,
  placeholder: undefined,
  selectProps: {},
  selectRef: undefined,
  size: 'default',
  state: undefined,
  value: undefined
};
var selectPropTypes = {
  a11yId: string,
  a11yLabel: string,
  autoComplete: string,
  autoFocus: bool,
  className: string,
  defaultValue: string,
  disabled: bool,
  isFullWidth: bool,
  isLoading: bool,
  isRequired: bool,
  name: string,
  options: array.isRequired,
  placeholder: string,
  selectProps: object,
  selectRef: object,
  size: string,
  state: string,
  value: string,
  onBlur: func,
  onChange: func,
  onFocus: func
};

var Select = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Select, _React$PureComponent);

  function Select() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      isPlaceholderSelected: Boolean(_this.props.placeholder)
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      var onChange = _this.props.onChange;

      _this.setState({
        isPlaceholderSelected: false
      });

      onChange && onChange(e);
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props = _this.props,
          a11yId = _this$props.a11yId,
          a11yLabel = _this$props.a11yLabel,
          autoComplete = _this$props.autoComplete,
          className = _this$props.className,
          autoFocus = _this$props.autoFocus,
          defaultValue = _this$props.defaultValue,
          disabled = _this$props.disabled,
          isFullWidth = _this$props.isFullWidth,
          isLoading = _this$props.isLoading,
          isRequired = _this$props.isRequired,
          name = _this$props.name,
          onBlur = _this$props.onBlur,
          onChange = _this$props.onChange,
          onFocus = _this$props.onFocus,
          options = _this$props.options,
          placeholder = _this$props.placeholder,
          selectProps = _this$props.selectProps,
          selectRef = _this$props.selectRef,
          size = _this$props.size,
          state = _this$props.state,
          value = _this$props.value,
          props = _objectWithoutPropertiesLoose(_this$props, ["a11yId", "a11yLabel", "autoComplete", "className", "autoFocus", "defaultValue", "disabled", "isFullWidth", "isLoading", "isRequired", "name", "onBlur", "onChange", "onFocus", "options", "placeholder", "selectProps", "selectRef", "size", "state", "value"]);

      var isPlaceholderSelected = _this.state.isPlaceholderSelected;
      return createElement(InlineBlock, _extends({
        relative: true,
        minWidth: "50px",
        width: isFullWidth ? '100%' : undefined
      }, props), createElement(_Select, _extends({
        "aria-invalid": state === 'danger',
        "aria-label": a11yLabel,
        "aria-required": isRequired,
        use: "select",
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue || placeholder,
        disabled: disabled,
        id: a11yId,
        isFullWidth: isFullWidth,
        isPlaceholderSelected: isPlaceholderSelected,
        name: name,
        onBlur: onBlur,
        onChange: _this.handleChange,
        onFocus: onFocus,
        elementRef: selectRef,
        styledSize: size,
        state: state,
        value: value
      }, selectProps), placeholder && createElement("option", {
        disabled: true,
        value: ""
      }, placeholder), options.map(function (option, i) {
        return createElement("option", {
          key: i // eslint-disable-line
          ,
          disabled: disabled || option.disabled,
          value: option.value
        }, option.label);
      })), isLoading ? createElement(LoadingSpinner, {
        color: "text",
        size: "1rem"
      }) : createElement(Icon, null));
    });

    return _this;
  }

  return Select;
}(PureComponent); // @ts-ignore


_defineProperty(Select, "defaultProps", selectDefaultProps);

_defineProperty(Select, "propTypes", selectPropTypes);

Select.Formik = formikField(Select); // @ts-ignore

Select.ReduxForm = reduxFormField(Select); // @ts-ignore

var C = Select;

var SelectField = function SelectField(_ref) {
  var a11yLabel = _ref.a11yLabel,
      a11yId = _ref.a11yId,
      addonBefore = _ref.addonBefore,
      addonAfter = _ref.addonAfter,
      autoComplete = _ref.autoComplete,
      autoFocus = _ref.autoFocus,
      className = _ref.className,
      description = _ref.description,
      defaultValue = _ref.defaultValue,
      disabled = _ref.disabled,
      hint = _ref.hint,
      isLoading = _ref.isLoading,
      isFullWidth = _ref.isFullWidth,
      isOptional = _ref.isOptional,
      isRequired = _ref.isRequired,
      isVertical = _ref.isVertical,
      label = _ref.label,
      name = _ref.name,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      options = _ref.options,
      placeholder = _ref.placeholder,
      selectProps = _ref.selectProps,
      selectRef = _ref.selectRef,
      size = _ref.size,
      state = _ref.state,
      validationText = _ref.validationText,
      value = _ref.value,
      props = _objectWithoutPropertiesLoose(_ref, ["a11yLabel", "a11yId", "addonBefore", "addonAfter", "autoComplete", "autoFocus", "className", "description", "defaultValue", "disabled", "hint", "isLoading", "isFullWidth", "isOptional", "isRequired", "isVertical", "label", "name", "onBlur", "onChange", "onFocus", "options", "placeholder", "selectProps", "selectRef", "size", "state", "validationText", "value"]);

  return createElement(FieldWrapper, _extends({
    a11yId: a11yId,
    description: description,
    hint: hint,
    isOptional: isOptional,
    isRequired: isRequired,
    label: label,
    state: state,
    validationText: validationText
  }, props), function (_ref2) {
    var elementProps = _ref2.elementProps;
    return createElement(ConditionalWrap, {
      condition: addonBefore || addonAfter,
      wrap: function wrap(children) {
        return createElement(Group, {
          isVertical: isVertical
        }, children);
      }
    }, addonBefore, createElement(C, _extends({
      a11yId: a11yId,
      a11yLabel: a11yLabel,
      autoComplete: autoComplete,
      autoFocus: autoFocus,
      className: className,
      defaultValue: defaultValue,
      disabled: disabled,
      isFullWidth: isFullWidth,
      isLoading: isLoading,
      isRequired: isRequired,
      name: name,
      options: options,
      placeholder: placeholder,
      selectProps: selectProps,
      selectRef: selectRef,
      size: size,
      state: state,
      value: value,
      onBlur: onBlur,
      onChange: onChange,
      onFocus: onFocus
    }, elementProps)), addonAfter);
  });
};

SelectField.Formik = formikField(SelectField, {
  hasFieldWrapper: true
});
SelectField.ReduxForm = reduxFormField(SelectField, {
  hasFieldWrapper: true
});

var selectFieldPropTypes = _objectSpread({
  addonBefore: element,
  addonAfter: element,
  isVertical: bool,
  selectProps: shape(selectPropTypes)
}, _omit(fieldWrapperPropTypes, 'children'), selectPropTypes);

SelectField.propTypes = selectFieldPropTypes;

var selectFieldDefaultProps = _objectSpread({
  addonBefore: undefined,
  addonAfter: undefined,
  isVertical: false,
  selectProps: {}
}, fieldWrapperDefaultProps, selectDefaultProps);

SelectField.defaultProps = selectFieldDefaultProps; // @ts-ignore

var C$1 = SelectField;
export { C as a, SelectField as b, selectFieldPropTypes as c, selectFieldDefaultProps as d, C$1 as e, selectDefaultProps as f, selectPropTypes as g };